/**
 * Minimal TooltipProvider wrapper.
 * Wraps @radix-ui/react-tooltip's provider for shadcn-style usage.
 */

import { Provider, Root, Trigger, Content, Portal } from "@radix-ui/react-tooltip";
import type { ReactNode, ComponentProps } from "react";

export function TooltipProvider({ children, delayDuration = 300 }: { children: ReactNode; delayDuration?: number }) {
  return (
    <Provider delayDuration={delayDuration}>
      {children}
    </Provider>
  );
}

export function Tooltip({ children }: { children: ReactNode }) {
  return <Root>{children}</Root>;
}

export function TooltipTrigger({ children, ...props }: ComponentProps<typeof Trigger>) {
  return <Trigger {...props}>{children}</Trigger>;
}

export function TooltipContent({ children, className = "", ...props }: ComponentProps<typeof Content>) {
  return (
    <Portal>
      <Content
        className={`z-50 overflow-hidden rounded-md border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 ${className}`}
        sideOffset={4}
        {...props}
      >
        {children}
      </Content>
    </Portal>
  );
}